// 除非既有的 code 有用到此檔案 否則不在裡頭加新東西
// API 網址請至 /apis/ 取
import dotenv from 'dotenv';

dotenv.config();

const API_SERVER_HOST_URL = process.env.REACT_APP_API_SERVER_HOST_URL;
const POI_BANK_HOST_URL = process.env.REACT_APP_POI_BANK_HOST_URL;
const WEB_SERVER_HOST_URL = process.env.REACT_APP_WEB_DOMAIN;

// web server
exports.webServerHostUrl = () => `${WEB_SERVER_HOST_URL}/`;

// poi bank
exports.poiBankHostUrl = () => POI_BANK_HOST_URL;
exports.fetchPoiBankInitUrl = () => `${POI_BANK_HOST_URL}auth/init`;
exports.fetchPoiBankInitCallBackUrl = () => `${POI_BANK_HOST_URL}auth/callback`;
exports.fetchDetailFromPoiBankUrl = () => `${POI_BANK_HOST_URL}poi/show`;
exports.fetchCityAutoCompleteUrl = () => `${POI_BANK_HOST_URL}poi/autocomplete`;
exports.fetchRecommendedPoiUrl = () => `${POI_BANK_HOST_URL}poi/recommend`;
exports.searchPoiUrl = () => `${POI_BANK_HOST_URL}poi/search`;
exports.cityGeocodeUrl = () => `${POI_BANK_HOST_URL}poi/geocode`;
exports.geocodingUrl = () => `${POI_BANK_HOST_URL}geocode/forward`;

// api server
exports.apiServerHostUrl = () => API_SERVER_HOST_URL;
exports.fetchInitUrl = () => `${API_SERVER_HOST_URL}api/init`;
exports.fetchPoisOfTripUrl = () => `getPoisOfTrip`;
exports.fetchRouteUrl = () => `getRoute`;
exports.postRouteUrl = () => `postRoute`;
exports.fetchPoiDetailFromItineraryUrl = () => `getPoiDetail`;
exports.fetchTextNoteUrl = () => `getTextNote`;
exports.loginUrl = () => `${API_SERVER_HOST_URL}api/login`;
exports.bindAccountUrl = () => `${API_SERVER_HOST_URL}api/bindAccount`;
exports.fetchMyTripListUrl = () => `getTripList`;
exports.fetchTravelGroupListUrl = () => `getSharedTripList`;
exports.getAvatarUrlByMemberId = memberId =>
  `${API_SERVER_HOST_URL}api/image?parseMemberObjectId=${memberId}`;
exports.updateTripInfoUrl = () => `updateTripInfo`;
exports.editAliasNameUrl = () => `editAliasNameOfPoi`;
exports.oneMoreDayUrl = () => `oneMoreDay`;
exports.postTextNoteUrl = () => `postTextNote`;
exports.updateStartTimeUrl = () => `editStartTime`;
exports.updateStayTimeUrl = () => `editStayTime`;
exports.reindexDaySequenceUrl = () => `reindexDaySequence`;
exports.reindexPoiSequenceUrl = () => `reindexPoiSequence`;
exports.copyPoiUrl = () => `copyPoi`;
exports.deletePoiUrl = () => `deletePois`;
exports.removeDaysUrl = () => `removeDays`;
exports.createTripUrl = () => `createTrip`;
exports.deleteTripUrl = () => `deleteTrip`;
exports.copyTripUrl = () => `copyTrip`;
exports.getCountOfInvitationsUrl = () => `getCountOfPendingInvitation`;
exports.acceptSharedTripUrl = () => `acceptJoinGroupInvitation`;
exports.acceptSendItineraryUrl = () => `acceptItinerary`;
exports.deleteSharedTripUrl = () => `deleteGroup`;
exports.customizeTransportationTimeUrl = () => `customizeTransportationTime`;
exports.addPoiToTripUrl = () => `addPoi`;

// collections
exports.fetchPoiDetailFromCollectionUrl = () => `getPoiDetailFromCollection`;
exports.fetchMyCollectionListUrl = () => `getCollections`;
exports.fetchSharedCollectionsFoldersUrl = () =>
  `getSharedCollectionsFolderList`;
exports.addPoiToCollectionsUrl = () => `addCollection`;

// itinerary link
exports.webLink = (userId, tripObjectId) =>
  `${WEB_SERVER_HOST_URL}/${userId}/trips/${tripObjectId}`;
